import { ReactNode } from "react";
import styled, { ThemeProvider } from "styled-components";
import { colors, PCProvider } from "@permisso/permisso-components";
import { useTheme } from "src/apps/providers/ThemeStore";
import { mapToPCTheme } from "src/apps/providers/mapToPCTheme";

// Full page error layout that only depends on the theme store (which has defaults), so it renders
// even where the router, translations or the customization providers are not mounted yet.
export const StandaloneErrorScreen = ({ children }: { children: ReactNode }) => {
  const theme = useTheme();
  // fontLinks is rendered by PCProvider, it is not part of the styled-components theme
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { fontLinks, ...styleTheme } = theme;

  return (
    <PCProvider theme={mapToPCTheme(theme)}>
      <ThemeProvider theme={styleTheme}>
        <Page>{children}</Page>
      </ThemeProvider>
    </PCProvider>
  );
};

const Page = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  box-sizing: border-box;
  background-color: ${colors.grey0};
`;
